import { useEffect } from "react";
import { emitter } from "../../input/AppEvents";
import CommandIdEnum from "../../enums/CommandIdEnums";
import { useViewerStateStore, ViewerLoadingStateEnum } from "../../store/viewerStateStore";
import { useDocumentsStateStore } from "../../store/documentsStateStore";

export interface CommandLauncherParams {
    commandId: CommandIdEnum;
    parameters?: unknown;
}

interface CommandLauncherComponentProps {
    commands: CommandLauncherParams[];
}

const CommandLauncherComponent = ({ commands }: CommandLauncherComponentProps) => {
    const loadingState = useViewerStateStore((state) => state.loadingState);
    const activeDocumentIndex = useDocumentsStateStore((state) => state.activeDocumentIndex);
    const commandsKey = commands.map(({ commandId, parameters }) => `${commandId}:${JSON.stringify(parameters)}`).join(",");

    useEffect(() => {
        if (loadingState === ViewerLoadingStateEnum.Staged && activeDocumentIndex !== -1) {
            commands.forEach(({ commandId, parameters }) => {
                emitter.emit("commandLaunch", { commandId, parameters });
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingState, activeDocumentIndex, commandsKey]);

    return null;
};

export default CommandLauncherComponent;
